module.exports = __webpack_public_path__ + "static/img/oily_t_zone-01.b0de375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/oily_t_zone-01.jpg
// module id = 280
// module chunks = 1